export const TRANSLATIONS = {
  es: {
    seo: {
      title: 'Cancún México | Guía Turística & Renta de Autos Oficial',
      description: 'Guía turística de Cancún y Riviera Maya: playas, cenotes, vida nocturna y rutas en auto. Tu mejor opción en renta de autos con Easy Way sin cargos ocultos.',
      keywords: 'cancun mexico travel, cancun turismo, guia turistica cancun, renta de autos en cancun, renta de autos en la riviera maya, car rental cancun, rent a car cancun, alquiler de autos cancun, easy way rent a car, playas cancun, cenotes cancun',
      ogTitle: 'Cancún México | Guía Turística & Renta de Autos Oficial',
      ogDescription: 'Guía turística de Cancún y Riviera Maya: playas, cenotes, vida nocturna y rutas en auto. Tu mejor opción en renta de autos con Easy Way sin cargos ocultos.',
      locale: 'es_MX',
    },
    nav: {
      topBadge: 'Su mejor opción en renta de autos',
      easyWay: 'Easy Way Rent a Car',
      autonomyText: 'Autonomía Total en tu Viaje',
      destinations: 'Lugares Icónicos',
      events: 'Eventos',
      festivals: 'Festivales',
      roadtrips: 'Rutas',
      drivingGuide: 'Consejos de Manejo',
      drivingTips: 'Consejos de Manejo',
      travelTips: 'Consejos de Viaje',
      savingsCalculator: 'Calculadora Ahorro',
      rentCta: 'Rentar en Easy Way',
      ftpDeploy: 'Publicar (1 Clic)',
      language: 'Idioma',
      selectLang: 'Seleccionar idioma',
    },
    hero: {
      tagline: 'Tu Aventura en el Caribe a tu Propio Ritmo',
      recommendationTag: 'Su mejor opción en renta de autos: Easy Way',
      headlinePrefix: 'Cancún al Volante: ',
      headlineHighlight: 'Guía Turística, Playas y Renta de Autos Sin Sorpresas',
      subheading: 'Descubre playas vírgenes, cenotes secretos y joyas mayas con la total libertad de un auto seguro y sin letras chiquitas. Compara costos reales de transporte y reserva con tarifas honestas.',
      searchPlaceholder: 'Busca playas, cenotes, clubes, ruinas...',
      clearSearch: 'Limpiar',
      statAttractions: 'Atracciones Verificadas',
      statFreedom: 'Libertad de Horarios',
      statSavings: 'Ahorro vs Taxis',
      exploreBtn: 'Explorar Directorio de Destinos',
      bookBtn: 'Cotizar Auto en Aeropuerto CUN',
      verifiedBadge: 'Precios Netos con Seguro Obligatorio Incluido',
    },
    categories: {
      todos: 'Todos',
      playas: 'Playas',
      cenotes: 'Cenotes',
      'vida-nocturna': 'Vida Nocturna',
      shopping: 'Shopping',
      roadtrips: 'Rutas en Auto',
      gastronomia: 'Gastronomía',
    },
    directory: {
      badge: 'Directorio de Destinos',
      title: 'Directorio de Playas, Cenotes y Destinos en Cancún & Riviera Maya',
      subtitle: '25 joyas seleccionadas para disfrutar al máximo en auto propio: distancias exactas, consejos de estacionamiento y datos locales.',
      searchPlaceholder: 'Buscar destino, playa o cenote...',
      sortRating: 'Mejor Valorados',
      sortTime: 'Más Cercanos',
      resultsFor: 'Mostrando resultados para',
      resetFilters: 'Restablecer filtros',
      allCategories: 'Todas las categorías',
      drivingTime: 'en auto',
      whyCar: 'Por qué ir en auto',
      parking: 'Estacionamiento',
      viewDetails: 'Ver Ficha Completa',
      getDirections: 'Cómo llegar',
      free: 'Gratis',
      noResults: 'No se encontraron destinos que coincidan con tu búsqueda.',
    },
    promo: {
      badge: 'Comparativa de Movilidad en Cancún',
      title: '¿Moverte en Taxi o Renta de Autos en Cancún con Easy Way?',
      subtitle: 'Compara la realidad de depender de taxis sin taxímetro o excursiones masivas frente a la tranquilidad de contar con un vehículo moderno y climatizado de nuestra agencia aliada recomendada.',
      intro: 'Compara la realidad de depender de taxis sin taxímetro o excursiones masivas frente a la tranquilidad de contar con un vehículo moderno y climatizado de nuestra agencia aliada recomendada: ',
      taxiTitle: 'Taxis Convencionales & Tours Masivos',
      taxiSubtitle: 'Altos costos, esperas bajo el sol e incertidumbre de tarifas',
      taxiPoint1Title: 'Tarifas Arbitrarias Sin Taxímetro',
      taxiPoint1Desc: 'Un solo trayecto Cancún - Playa del Carmen puede superar los $80-$120 USD. En horas pico o lluvia los precios se duplican.',
      taxiPoint2Title: 'Pérdida de Tiempo y Rigidez',
      taxiPoint2Desc: 'Depender de horarios fijos de tours o esperar taxis en carreteras rurales de cenotes bajo el calor húmedo caribeño.',
      taxiPoint3Title: 'Paradas Comerciales Obligatorias',
      taxiPoint3Desc: 'Los tours colectivos dedican hasta 2 horas a paradas comerciales forzadas de souvenirs y apresuran tu tiempo en zonas arqueológicas.',
      taxiPoint4Title: 'Cobros Acumulativos por Persona',
      taxiPoint4Desc: 'Cada traslado multiplica el costo familiar; en solo 4 días de estancia el gasto en taxis puede superar los $500 USD.',
      taxiExpenseLabel: 'Gasto estimado en 5 días de taxis & traslados:',
      taxiExpenseValue: '$8,500 - $14,000+ MXN',
      easyWayTitle: 'Libertad Total con Easy Way Rent a Car',
      easyWaySubtitle: 'Tarifas honestas con seguro obligatorio incluido y atención 24/7',
      winnerBadge: 'La Opción Más Inteligente',
      savingsPointTitle: 'Ahorro Real de hasta un 65%',
      savingsPointDesc: 'Un único pago fijo diario para toda la familia o grupo. Todo el kilometraje que desees sin sorpresas ni letras pequeñas.',
      spontaneousPointTitle: 'Exploración a tu Propio Ritmo',
      spontaneousPointDesc: 'Llega antes de que abran las ruinas de Tulum o Chichén Itzá para fotos sin multitudes, y nada en cenotes vírgenes sin prisa.',
      zeroSurprisesTitle: 'Tarifas Netas Sin Letras Chiquitas',
      zeroSurprisesDesc: 'El monto cotizado incluye el seguro obligatorio mexicano (daños a terceros / PLI). Cero cargos inventados en mostrador.',
      comfortTitle: 'Vehículos Modernos y Climatizados',
      comfortDesc: 'Flota reciente con aire acondicionado al 100%, recepción directa y asistencia 24/7 en carretera en todo Quintana Roo y Yucatán.',
      investmentLabel: 'Inversión estimada por día de auto:',
      investmentValue: 'Desde ~$550 - $850 MXN/día',
      bookBtn: 'Cotizar con Seguro Incluido',
      reassuranceBadge: 'Transparencia Garantizada',
      reassuranceTitle: 'Más de 25 Años Respaldando a Viajeros en el Caribe Mexicano',
      reassuranceDesc: 'Easy Way Rent a Car se distingue por contratos transparentes, sin tarifas engañosas ni retenciones abusivas. Tu vehículo te espera listo al aterrizar.',
      exploreFleetBtn: 'Ver Flota y Cotizar Ahora',
      phoneSupport: 'Asistencia telefónica directa 24/7',
    },
    calculator: {
      badge: 'Calculadora Interactiva de Transporte',
      title: 'Calculadora de Ahorro: Renta de Autos vs Taxis en Cancún',
      subtitle: 'Compara el costo real de moverte en taxis o traslados privados frente a la renta de un auto con Easy Way en Cancún y la Riviera Maya.',
      stayDays: 'Días de Estancia:',
      daysLabel: 'Días de Estancia:',
      passengers: 'Pasajeros:',
      travelersLabel: 'Pasajeros:',
      carSameCostNote: '*La renta del auto cuesta lo mismo para 1 o 5 personas; los taxis multiplican costos.',
      routesTitle: 'Rutas Planificadas',
      plannedRoutes: 'Rutas Planificadas:',
      estimatedSavings: 'Ahorro Estimado',
      percentLess: 'Menos que en Taxi',
      youSaveAround: 'Ahorras aproximadamente',
      traditionalTaxis: 'Taxis Convencionales / Tours',
      easyWayGas: 'Easy Way (Auto + Gasolina Est.)',
      taxiTotal: 'Costo Estimado en Taxis / Tours',
      carTotal: 'Costo Total con Easy Way (Auto + Gasolina)',
      savingsTotal: '¡Tu Ahorro Neto Estimado!',
      celebrateBtn: '¡Calcular y Celebrar Ahorro!',
      secureSavingsBtn: 'Asegurar Este Ahorro en Easy Way',
      bookWithPlan: 'Cotizar con Esta Configuración en Easy Way',
      adviceText: 'Reserva con anticipación con Easy Way para asegurar la mejor tarifa en Cancún y la Riviera Maya.',
    },
    roadtrips: {
      badge: 'Itinerarios Recomendados en Auto',
      title: 'Rutas Escénicas en Auto desde Cancún hacia Riviera Maya & Yucatán',
      subtitle: 'Diseñadas para aprovechar cada kilómetro en carretera: tiempos exactos, paradas estratégicas y consejos de estacionamiento.',
      difficulty: 'Dificultad',
      gasEst: 'Gasolina est.',
      tolls: 'Casetas',
      stopsTitle: 'Itinerario Sugerido',
      carTip: 'Consejo al Volante',
    },
    drivingGuide: {
      badge: 'Guía Vial de Quintana Roo & Yucatán',
      title: 'Guía y Consejos Esenciales para Conducir en Cancún',
      subtitle: 'Normativa de tránsito, mitos sobre seguros de tarjetas de crédito, qué hacer ante retenes policiales y cómo evitar estafas en gasolineras.',
      tabInsurance: 'Seguro Obligatorio',
      tabLegal: 'Retenes & Tránsito',
      tabDriving: 'Gasolineras & Rutas',
      assistanceBadge: 'Asistencia Vial Inmediata',
      needCarTitle: '¿Planeas Tu Viaje por Cancún y Riviera Maya?',
      needCarSubtitle: 'Reserva con Easy Way Rent a Car: seguros claros, kilometraje ilimitado y entrega rápida en el Aeropuerto de Cancún.',
      goToEasyWay: 'Cotizar en Aeropuerto de Cancún',
      crossNavTitle: '¿Llegas por Avión al Aeropuerto de Cancún (CUN)?',
      crossNavSubtitle: 'Revisa nuestra guía de aduanas, requisitos migratorios, casas de cambio y el Shark Tank de transportistas.',
      crossNavBtn: 'Ver Consejos de Aeropuerto y Viaje',
      cdwTitle: 'El Gran Mito del Seguro de Tarjeta de Crédito en México',
      gasTitle: 'Protocolo en Gasolineras Locales',
      policeTitle: 'Retenes y Normativa Vial',
      tollsTitle: 'Carreteras Libres vs Autopistas de Cuota',
    },
    driving: {
      badge: 'Guía Vial de Quintana Roo & Yucatán',
      title: 'Guía y Consejos Esenciales para Conducir en Cancún',
      subtitle: 'Normativa de tránsito, mitos sobre seguros de tarjetas de crédito, qué hacer ante retenes policiales y cómo evitar estafas en gasolineras.',
      tabInsurance: 'Seguro Obligatorio',
      tabLegal: 'Retenes & Tránsito',
      tabDriving: 'Gasolineras & Rutas',
      assistanceBadge: 'Asistencia Vial Inmediata',
      needCarTitle: '¿Planeas Tu Viaje por Cancún y Riviera Maya?',
      needCarSubtitle: 'Reserva con Easy Way Rent a Car: seguros claros, kilometraje ilimitado y entrega rápida en el Aeropuerto de Cancún.',
      goToEasyWay: 'Cotizar en Aeropuerto de Cancún',
      crossNavTitle: '¿Llegas por Avión al Aeropuerto de Cancún (CUN)?',
      crossNavSubtitle: 'Revisa nuestra guía de aduanas, requisitos migratorios, casas de cambio y el Shark Tank de transportistas.',
      crossNavBtn: 'Ver Consejos de Aeropuerto y Viaje',
      cdwTitle: 'El Gran Mito del Seguro de Tarjeta de Crédito en México',
      gasTitle: 'Protocolo en Gasolineras Locales',
      policeTitle: 'Retenes y Normativa Vial',
      tollsTitle: 'Carreteras Libres vs Autopistas de Cuota',
    },
    travel: {
      badge: 'Llegada al Aeropuerto de Cancún',
      title: 'Guía Práctica de Viaje: Aduana, Divisas y Llegada',
      subtitle: 'Todo lo que necesitas saber desde que aterriza tu vuelo hasta que tomas las llaves de tu auto de Easy Way sin contratiempos.',
    },
    events: {
      badge: 'Agenda Cultural & Festivales',
      title: 'Eventos y Tradiciones Anuales en Cancún',
      subtitle: 'Vive la música, folclor y celebraciones mayas que puedes visitar cómodamente en auto durante todo el año.',
    },
    faq: {
      badge: 'Preguntas Frecuentes',
      title: 'Preguntas Frecuentes sobre Turismo y Renta de Autos en Cancún',
      subtitle: 'Respuestas claras y directas sobre la renta de autos con Easy Way, carreteras y estacionamiento.',
      checkFleet: 'Consultar flota y disponibilidad oficial',
    },
    faqs: {
      badge: 'Preguntas Frecuentes',
      title: 'Preguntas Frecuentes sobre Turismo y Renta de Autos en Cancún',
      subtitle: 'Respuestas claras y directas sobre la renta de autos con Easy Way, carreteras y estacionamiento.',
      checkFleet: 'Consultar flota y disponibilidad oficial',
    },
    footer: {
      topBadge: 'Su mejor opción en renta de autos',
      topTitle: '¿Listo para Recorrer Cancún a tu Propio Ritmo?',
      topSubtitle: 'Reserva tu auto con Easy Way Rent a Car. Más de 25 años garantizando tarifas honestas, sin sorpresas ni depósitos abusivos en el Caribe Mexicano.',
      quoteBtn: 'Cotizar Auto en Aeropuerto CUN',
      brandDesc: 'Guía independiente de turismo y movilidad por carretera en Cancún, la Riviera Maya y la Península de Yucatán. Información clara y objetiva para recorrer el paraíso con total seguridad.',
      destinationsTitle: 'Destinos Populares',
      experiencesTitle: 'Rutas & Consejos',
      recommendationPill: 'Recomendado',
      recommendationDesc: 'Su mejor opción en renta de autos con más de 25 años en el Caribe Mexicano. Precios honestos con seguro obligatorio incluido.',
      quickLinks: 'Secciones de la Guía',
      disclaimer: 'Guía turística y de movilidad informativa. Promovemos la exploración segura y transparente en Cancún y la Península de Yucatán.',
      allRights: 'Todos los derechos reservados.',
      websiteUrl: 'easywayrentacar.com/es',
      copyright: '© 2026 CancunMexico.travel — Todos los derechos reservados.',
      craftedFor: 'Diseñado con precisión para una experiencia de viaje inigualable en el Caribe Mexicano.',
    },
    modal: {
      drivingTime: 'Tiempo estimado en auto',
      parking: 'Estacionamiento',
      whyCar: 'Por qué visitar en auto',
      insiderTip: 'Consejo de experto',
      bestTime: 'Mejor momento para visitar',
      priceRange: 'Rango de precio',
      openMaps: 'Abrir en Google Maps',
      quoteCar: 'Cotizar Auto para Este Destino con Easy Way',
      close: 'Cerrar',
      recommendedMobility: 'Movilidad Recomendada &bull; Easy Way Rent a Car',
    },
    floating: {
      whatsappChat: 'WhatsApp Easy Way',
      callDirect: 'Llamar a Easy Way',
      openQuote: 'Cotizar en Línea',
      websiteUrl: 'easywayrentacar.com/es',
    },
  },
  en: {
    seo: {
      title: 'Cancun Travel Guide | Best Car Rental & Attractions',
      description: 'The definitive Cancun & Riviera Maya travel guide: top beaches, cenotes & scenic road trips. Your best car rental choice with Easy Way, zero hidden fees.',
      keywords: 'cancun travel guide, things to do in cancun, car rental cancun, cancun car rental, rent a car cancun, easy way rent a car, riviera maya car rental, cancun beaches, cancun cenotes',
      ogTitle: 'Cancun Travel Guide | Best Car Rental & Attractions',
      ogDescription: 'The definitive Cancun & Riviera Maya travel guide: top beaches, cenotes & scenic road trips. Your best car rental choice with Easy Way, zero hidden fees.',
      locale: 'en_US',
    },
    nav: {
      topBadge: 'Your best choice in car rental',
      easyWay: 'Easy Way Rent a Car',
      autonomyText: 'Total Freedom on Your Trip',
      destinations: 'Top Attractions',
      events: 'Events',
      festivals: 'Festivals',
      roadtrips: 'Road Trips',
      drivingGuide: 'Driving Guide',
      drivingTips: 'Driving Guide',
      travelTips: 'Travel & Airport Tips',
      savingsCalculator: 'Savings Calculator',
      rentCta: 'Rent with Easy Way',
      ftpDeploy: 'Publish (1 Click)',
      language: 'Language',
      selectLang: 'Select language',
    },
    hero: {
      tagline: 'Your Caribbean Adventure at Your Own Pace',
      recommendationTag: 'Your best choice in car rental: Easy Way',
      headlinePrefix: 'Cancun Travel Guide: ',
      headlineHighlight: 'Explore Beaches, Cenotes & Top Car Rental with Ease',
      subheading: 'Discover virgin beaches, hidden cenotes, and Mayan wonders with complete freedom in a reliable car without fine print. Compare real transport costs and book with honest rates.',
      searchPlaceholder: 'Search beaches, cenotes, clubs, ruins...',
      clearSearch: 'Clear',
      statAttractions: 'Verified Attractions',
      statFreedom: 'Total Freedom',
      statSavings: 'Savings vs Taxis',
      exploreBtn: 'Explore Attractions Directory',
      bookBtn: 'Quote Car at Cancun Airport',
      verifiedBadge: 'Net Rates with Mandatory Insurance Included',
    },
    categories: {
      todos: 'All',
      playas: 'Beaches',
      cenotes: 'Cenotes',
      'vida-nocturna': 'Nightlife',
      shopping: 'Shopping',
      roadtrips: 'Road Trips',
      gastronomia: 'Dining',
    },
    directory: {
      badge: 'Destinations Directory',
      title: 'Cancun Beaches, Cenotes & Attractions Directory',
      subtitle: '25 handpicked gems to experience with your own vehicle: exact distances, parking tips, and local insider insights.',
      searchPlaceholder: 'Search destination, beach or cenote...',
      sortRating: 'Highest Rated',
      sortTime: 'Closest to You',
      resultsFor: 'Showing results for',
      resetFilters: 'Reset filters',
      allCategories: 'All categories',
      drivingTime: 'drive',
      whyCar: 'Why visit by car',
      parking: 'Parking Info',
      viewDetails: 'View Full Details',
      getDirections: 'Get Directions',
      free: 'Free',
      noResults: 'No destinations found matching your search.',
    },
    promo: {
      badge: 'Cancun Mobility Comparison',
      title: 'Take Expensive Taxis or Cancun Car Rental with Easy Way?',
      subtitle: 'Compare the reality of meterless taxis and crowded tour buses against the peace of mind of having your own modern, air-conditioned car with our recommended partner.',
      intro: 'Compare the reality of meterless taxis and crowded tour buses against the peace of mind of having your own modern, air-conditioned car with our recommended partner: ',
      taxiTitle: 'Regular Taxis & Group Tours',
      taxiSubtitle: 'High prices, waiting in tropical heat, and fare uncertainty',
      taxiPoint1Title: 'Arbitrary Rates Without Taximeters',
      taxiPoint1Desc: 'A single trip from Cancun to Playa del Carmen often exceeds $80-$120 USD. Peak hours or rain can double the price unpredictably.',
      taxiPoint2Title: 'Wasted Time & Rigid Schedules',
      taxiPoint2Desc: 'Stuck with rigid tour bus departure times or waiting endlessly for rural road taxis near cenotes under hot sun.',
      taxiPoint3Title: 'Forced Commercial Souvenir Stops',
      taxiPoint3Desc: 'Mass tour buses regularly waste 2 hours at sponsored gift shops, drastically cutting your time at Mayan ruins and cenotes.',
      taxiPoint4Title: 'Per-Person Cumulative Costs',
      taxiPoint4Desc: 'Every single excursion multiplies family travel costs; a typical 4-5 day stay easily exceeds $500-$700 USD in taxis alone.',
      taxiExpenseLabel: 'Estimated 5-day cost with taxis & transfers:',
      taxiExpenseValue: '$8,500 - $14,000+ MXN (~$500-$800 USD)',
      easyWayTitle: 'Total Autonomy with Easy Way Rent a Car',
      easyWaySubtitle: 'Transparent pricing with mandatory insurance included & 24/7 assistance',
      winnerBadge: 'The Smartest Choice',
      savingsPointTitle: 'Real Savings of up to 65%',
      savingsPointDesc: 'One flat daily rate covers your entire family or group. Drive anywhere in the peninsula with 100% unlimited mileage.',
      spontaneousPointTitle: 'Explore at Your Own Pace',
      spontaneousPointDesc: 'Arrive at Tulum or Chichén Itzá before tour crowds descend for pristine photos, and stay at secret cenotes as long as you want.',
      zeroSurprisesTitle: 'Net Rates with Zero Fine Print',
      zeroSurprisesDesc: 'The price quoted is your final net rate, including mandatory Mexican third-party liability insurance (PLI). No counter surprises.',
      comfortTitle: 'Modern, Ice-Cold A/C Vehicles',
      comfortDesc: 'Recent vehicle fleet with powerful air conditioning, swift airport pickup, and 24/7 roadside assistance across Quintana Roo and Yucatan.',
      investmentLabel: 'Estimated car investment per day:',
      investmentValue: 'From ~$30 - $48 USD/day (~$550-$850 MXN)',
      bookBtn: 'Quote Car with Insurance Included',
      reassuranceBadge: 'Guaranteed Transparency',
      reassuranceTitle: 'Over 25 Years Serving Travelers in the Mexican Caribbean',
      reassuranceDesc: 'Easy Way Rent a Car has built a stellar reputation with straightforward rental terms, no fake promises, and no predatory deposits. Your car is ready when you touch down.',
      exploreFleetBtn: 'View Fleet & Quote Now',
      phoneSupport: '24/7 Direct Phone & WhatsApp Support',
    },
    calculator: {
      badge: 'Interactive Transport Calculator',
      title: 'Savings Calculator: Car Rental vs Taxis in Cancun',
      subtitle: 'Compare the real cost of taxis and private transfers against renting a car with Easy Way in Cancun and the Riviera Maya.',
      stayDays: 'Days of Stay:',
      daysLabel: 'Days of Stay:',
      passengers: 'Travelers:',
      travelersLabel: 'Travelers:',
      carSameCostNote: '*Car rental costs the same for 1 or 5 passengers; taxi fares multiply with groups.',
      routesTitle: 'Planned Itineraries',
      plannedRoutes: 'Planned Itineraries:',
      estimatedSavings: 'Estimated Savings',
      percentLess: 'Less than Taxis',
      youSaveAround: 'You save around',
      traditionalTaxis: 'Conventional Taxis / Tours',
      easyWayGas: 'Easy Way (Car + Est. Fuel)',
      taxiTotal: 'Estimated Taxi & Tour Cost',
      carTotal: 'Total Cost with Easy Way (Car + Fuel)',
      savingsTotal: 'Your Estimated Net Savings!',
      celebrateBtn: 'Calculate & Celebrate Savings!',
      secureSavingsBtn: 'Lock In These Savings with Easy Way',
      bookWithPlan: 'Get Quote for This Itinerary on Easy Way',
      adviceText: 'Book in advance with Easy Way to lock in the best available rate for Cancun and the Riviera Maya.',
    },
    roadtrips: {
      badge: 'Recommended Driving Itineraries',
      title: 'Scenic Road Trips from Cancun across Riviera Maya & Yucatan',
      subtitle: 'Designed to maximize every mile on the highway: exact driving times, strategic stops, and parking guidance.',
      difficulty: 'Difficulty',
      gasEst: 'Est. Gas',
      tolls: 'Tolls',
      stopsTitle: 'Suggested Itinerary',
      carTip: 'Driving Tip',
    },
    drivingGuide: {
      badge: 'Quintana Roo & Yucatan Driving Guide',
      title: 'Essential Driving Tips in Cancun & Riviera Maya',
      subtitle: 'Traffic regulations, credit card insurance myths debunked, police checkpoint protocols, and avoiding gas station scams.',
      tabInsurance: 'Mandatory Insurance',
      tabLegal: 'Checkpoints & Laws',
      tabDriving: 'Gas & Highways',
      assistanceBadge: '24/7 Roadside Assistance',
      needCarTitle: 'Planning Your Road Trip in Cancun & Riviera Maya?',
      needCarSubtitle: 'Book with Easy Way Rent a Car: clear insurance, unlimited mileage, and rapid Cancun Airport meet-and-greet.',
      goToEasyWay: 'Quote at Cancun Airport',
      crossNavTitle: 'Arriving by Plane at Cancun Airport (CUN)?',
      crossNavSubtitle: 'Check our guide to customs limits, immigration paperwork, currency exchanges, and dodging the arrival hall Shark Tank.',
      crossNavBtn: 'View Airport & Travel Tips',
      cdwTitle: 'The Big Credit Card Insurance Myth in Mexico',
      gasTitle: 'Local Gas Station Protocols',
      policeTitle: 'Police Checkpoints & Traffic Rules',
      tollsTitle: 'Free Roads vs Toll Highways',
    },
    driving: {
      badge: 'Quintana Roo & Yucatan Driving Guide',
      title: 'Essential Driving Tips in Cancun & Riviera Maya',
      subtitle: 'Traffic regulations, credit card insurance myths debunked, police checkpoint protocols, and avoiding gas station scams.',
      tabInsurance: 'Mandatory Insurance',
      tabLegal: 'Checkpoints & Laws',
      tabDriving: 'Gas & Highways',
      assistanceBadge: '24/7 Roadside Assistance',
      needCarTitle: 'Planning Your Road Trip in Cancun & Riviera Maya?',
      needCarSubtitle: 'Book with Easy Way Rent a Car: clear insurance, unlimited mileage, and rapid Cancun Airport meet-and-greet.',
      goToEasyWay: 'Quote at Cancun Airport',
      crossNavTitle: 'Arriving by Plane at Cancun Airport (CUN)?',
      crossNavSubtitle: 'Check our guide to customs limits, immigration paperwork, currency exchanges, and dodging the arrival hall Shark Tank.',
      crossNavBtn: 'View Airport & Travel Tips',
      cdwTitle: 'The Big Credit Card Insurance Myth in Mexico',
      gasTitle: 'Local Gas Station Protocols',
      policeTitle: 'Police Checkpoints & Traffic Rules',
      tollsTitle: 'Free Roads vs Toll Highways',
    },
    travel: {
      badge: 'Cancun Airport Arrival Guide',
      title: 'Practical Travel Guide: Customs, Currency & Arrival',
      subtitle: 'Everything you need to know from the minute your flight lands until you grab your Easy Way rental keys seamlessly.',
    },
    events: {
      badge: 'Cultural Agenda & Festivals',
      title: 'Annual Events & Celebrations in Cancun',
      subtitle: 'Experience live music, folklore, and Mayan traditions easily accessible by car all year long.',
    },
    faq: {
      badge: 'Frequently Asked Questions',
      title: 'Cancun Travel Guide & Car Rental FAQs',
      subtitle: 'Clear and direct answers regarding car rentals with Easy Way, local roads, and parking.',
      checkFleet: 'Check official fleet and availability',
    },
    faqs: {
      badge: 'Frequently Asked Questions',
      title: 'Cancun Travel Guide & Car Rental FAQs',
      subtitle: 'Clear and direct answers regarding car rentals with Easy Way, local roads, and parking.',
      checkFleet: 'Check official fleet and availability',
    },
    footer: {
      topBadge: 'Your best choice in car rental',
      topTitle: 'Ready to Discover Cancun at Your Own Rhythm?',
      topSubtitle: 'Reserve your car with Easy Way Rent a Car. Over 25 years guaranteeing honest rates, zero surprises, and no predatory deposits in the Mexican Caribbean.',
      quoteBtn: 'Quote Car at Cancun Airport',
      brandDesc: 'Independent road travel and mobility guide for Cancun, the Riviera Maya, and the Yucatan Peninsula. Objective, verified advice for hassle-free exploration.',
      destinationsTitle: 'Popular Destinations',
      experiencesTitle: 'Routes & Advice',
      recommendationPill: 'Recommended',
      recommendationDesc: 'Your best choice in car rental with over 25 years in the Mexican Caribbean. Honest rates with mandatory insurance included.',
      quickLinks: 'Guide Navigation',
      disclaimer: 'Educational and travel mobility guide. We promote safe, responsible, and transparent road exploration in Cancun and the Yucatan Peninsula.',
      allRights: 'All rights reserved.',
      websiteUrl: 'easywayrentacar.com',
      copyright: '© 2026 CancunMexico.travel — All rights reserved.',
      craftedFor: 'Engineered for an unmatched road trip experience in the Mexican Caribbean.',
    },
    modal: {
      drivingTime: 'Estimated driving time',
      parking: 'Parking info',
      whyCar: 'Why visit by car',
      insiderTip: 'Local insider tip',
      bestTime: 'Best time to visit',
      priceRange: 'Price range',
      openMaps: 'Open in Google Maps',
      quoteCar: 'Get Car Quote for this Destination with Easy Way',
      close: 'Close',
      recommendedMobility: 'Recommended Mobility &bull; Easy Way Rent a Car',
    },
    floating: {
      whatsappChat: 'WhatsApp Easy Way',
      callDirect: 'Call Easy Way',
      openQuote: 'Book Online',
      websiteUrl: 'easywayrentacar.com',
    },
  },

  pt: {
    seo: {
      title: 'Guia de Viagem Cancun | Melhor Aluguel de Carros e Atrações',
      description: 'O guia definitivo de Cancun e Riviera Maya: melhores praias, cenotes e roteiros. A melhor escolha para aluguel de carros é a Easy Way, sem taxas ocultas.',
      keywords: 'guia de viagem cancun, o que fazer em cancun, aluguel de carros cancun, alugar carro cancun, easy way rent a car, aluguel de carros riviera maya, praias de cancun, cenotes cancun',
      ogTitle: 'Guia de Viagem Cancun | Melhor Aluguel de Carros e Atrações',
      ogDescription: 'O guia definitivo de Cancun e Riviera Maya: melhores praias, cenotes e roteiros. A melhor escolha para aluguel de carros é a Easy Way, sem taxas ocultas.',
      locale: 'pt_BR',
    },
    nav: {
      topBadge: 'A melhor escolha em aluguel de carros',
      easyWay: 'Easy Way Rent a Car',
      autonomyText: 'Liberdade Total na sua Viagem',
      destinations: 'Principais Atrações',
      events: 'Eventos',
      festivals: 'Festivais',
      roadtrips: 'Roteiros',
      drivingGuide: 'Guia de Direção',
      drivingTips: 'Guia de Direção',
      travelTips: 'Dicas de Viagem',
      savingsCalculator: 'Calculadora de Economia',
      rentCta: 'Alugar com a Easy Way',
      ftpDeploy: 'Publicar (1 Clique)',
      language: 'Idioma',
      selectLang: 'Selecionar idioma',
    },
    hero: {
      tagline: 'Sua Aventura no Caribe no Seu Próprio Ritmo',
      recommendationTag: 'Sua melhor escolha em aluguel de carros: Easy Way',
      headlinePrefix: 'Guia de Viagem Cancun: ',
      headlineHighlight: 'Explore Praias, Cenotes e Alugue um Carro com Facilidade',
      subheading: 'Descubra praias virgens, cenotes escondidos e maravilhas maias com total liberdade em um carro confiável e sem letras miúdas. Compare os custos reais de transporte e reserve com tarifas honestas.',
      searchPlaceholder: 'Pesquise praias, cenotes, clubes, ruínas...',
      clearSearch: 'Limpar',
      statAttractions: 'Atrações Verificadas',
      statFreedom: 'Total Liberdade',
      statSavings: 'Economia vs Táxis',
      exploreBtn: 'Explorar Diretório de Atrações',
      bookBtn: 'Cotar Carro no Aeroporto de Cancún',
      verifiedBadge: 'Tarifas Líquidas com Seguro Obrigatório Incluído',
    },
    categories: {
      todos: 'Todos',
      playas: 'Praias',
      cenotes: 'Cenotes',
      'vida-nocturna': 'Vida Noturna',
      shopping: 'Compras',
      roadtrips: 'Roteiros',
      gastronomia: 'Gastronomia',
    },
    directory: {
      title: 'Diretório de Atrações em Cancun e Riviera Maya',
      subtitle: 'O guia mais completo para planejar sua rota. Evite tours superfaturados e chegue por conta própria às praias, cenotes e ruínas arqueológicas que as agências não mostram.',
      viewDetails: 'Ver Detalhes e Estacionamento',
      noResults: 'Nenhuma atração encontrada para sua busca.',
      exploreArea: 'Explorar por Área',
      distanceCancun: 'Distância do Centro de Cancun',
      bestTime: 'Melhor Horário para Visitar',
      parking: 'Estacionamento',
      whyCar: 'Por que ir de Carro',
      bookEasyWay: 'Cotar em easywayrentacar.com',
      reassuranceBadge: 'Transparência Garantida',
      reassuranceTitle: 'Mais de 25 Anos Servindo Viajantes no Caribe Mexicano',
      reassuranceDesc: 'A Easy Way Rent a Car construiu uma reputação estelar com termos de aluguel claros, sem promessas falsas e sem depósitos predatórios. Seu carro estará pronto quando você desembarcar.',
      exploreFleetBtn: 'Ver Frota e Cotar Agora',
      phoneSupport: 'Suporte Direto 24/7 via Telefone e WhatsApp',
      badge: 'Diretório de Destinos',
      searchPlaceholder: 'Buscar destino, praia ou cenote...',
      sortRating: 'Melhor Avaliados',
      sortTime: 'Mais Próximos',
      resultsFor: 'Mostrando resultados para',
      resetFilters: 'Restaurar filtros',
      allCategories: 'Todas as categorias',
      drivingTime: 'de carro',
      getDirections: 'Como chegar',
      free: 'Grátis',
    },
    promo: {
      badge: 'Comparativo de Mobilidade em Cancun',
      title: 'Pegar Táxis Caros ou Alugar Carro em Cancun com a Easy Way?',
      subtitle: 'Compare a realidade de táxis sem taxímetro e ônibus de turismo lotados com a tranquilidade de ter seu próprio carro moderno e com ar-condicionado.',
      intro: 'Compare a realidade de depender de táxis sem taxímetro ou excursões lotadas em comparação com a tranquilidade de ter um veículo moderno com nossa agência parceira recomendada: ',
      taxiTitle: 'Táxis Convencionais e Tours em Grupo',
      taxiSubtitle: 'Preços altos, espera no calor tropical e incerteza de tarifas',
      taxiPoint1Title: 'Tarifas Arbitrárias Sem Taxímetro',
      taxiPoint1Desc: 'Uma única viagem de Cancun a Playa del Carmen costuma passar de $80-$120 USD. Horários de pico ou chuva podem dobrar o preço imprevisivelmente.',
      taxiPoint2Title: 'Tempo Perdido e Horários Rígidos',
      taxiPoint2Desc: 'Ficar preso aos horários de partida de ônibus de turismo ou esperar indefinidamente por táxis em estradas rurais perto de cenotes sob o sol quente.',
      taxiPoint3Title: 'Paradas Comerciais Forçadas',
      taxiPoint3Desc: 'Ônibus de excursões gastam até 2 horas em paradas comerciais para comprar lembranças, cortando drasticamente seu tempo nas ruínas e cenotes.',
      taxiPoint4Title: 'Custos Cumulativos por Pessoa',
      taxiPoint4Desc: 'Cada passeio multiplica os custos de viagem da família; uma estadia de 4 dias excede facilmente $500-$700 USD apenas em táxis.',
      taxiExpenseLabel: 'Gasto estimado em 5 dias com táxis e traslados:',
      taxiExpenseValue: '$8.500 - $14.000+ MXN (~$500-$800 USD)',
      easyWayTitle: 'Autonomia Total com Easy Way Rent a Car',
      easyWaySubtitle: 'Preços transparentes com seguro obrigatório incluído e assistência 24/7',
      winnerBadge: 'A Escolha Mais Inteligente',
      savingsPointTitle: 'Economia Real de até 65%',
      savingsPointDesc: 'Uma única taxa diária fixa para toda a sua família ou grupo. Dirija por toda a península com quilometragem 100% ilimitada.',
      spontaneousPointTitle: 'Explore no Seu Próprio Ritmo',
      spontaneousPointDesc: 'Chegue a Tulum ou Chichén Itzá antes das multidões para tirar fotos, e fique em cenotes secretos o tempo que quiser.',
      zeroSurprisesTitle: 'Tarifas Líquidas Sem Surpresas',
      zeroSurprisesDesc: 'O preço cotado é sua tarifa líquida final, incluindo o seguro obrigatório de responsabilidade civil no México (PLI). Sem surpresas no balcão.',
      comfortTitle: 'Veículos Modernos e Climatizados',
      comfortDesc: 'Frota recente com forte ar-condicionado, recepção rápida no aeroporto e assistência rodoviária 24/7 em Quintana Roo e Yucatán.',
      investmentLabel: 'Investimento diário estimado no carro:',
      investmentValue: 'A partir de ~$30 - $48 USD/dia (~$550-$850 MXN)',
      bookBtn: 'Cotar Carro com Seguro Incluído',
      reassuranceBadge: 'Transparência Garantida',
      reassuranceTitle: 'Mais de 25 Anos Servindo Viajantes no Caribe Mexicano',
      reassuranceDesc: 'A Easy Way Rent a Car construiu uma reputação estelar com termos de aluguel claros, sem promessas falsas e sem depósitos predatórios. Seu carro estará pronto quando você desembarcar.',
      exploreFleetBtn: 'Ver Frota e Cotar Agora',
      phoneSupport: 'Suporte Direto 24/7 via Telefone e WhatsApp',
    },
    calculator: {
      badge: 'Calculadora Interativa de Transporte',
      title: 'Calculadora de Economia: Aluguel de Carros vs Táxis em Cancun',
      subtitle: 'Compare o custo real de táxis e traslados particulares com o aluguel de carro na Easy Way em Cancun e na Riviera Maya.',
      stayDays: 'Dias de Estadia:',
      daysLabel: 'Dias de Estadia:',
      passengers: 'Viajantes:',
      travelersLabel: 'Viajantes:',
      carSameCostNote: '*O aluguel do carro custa o mesmo para 1 ou 5 passageiros; tarifas de táxi se multiplicam com grupos.',
      routesTitle: 'Roteiros Planejados',
      plannedRoutes: 'Roteiros Planejados:',
      estimatedSavings: 'Economia Estimada',
      percentLess: 'Menos que Táxis',
      youSaveAround: 'Você economiza em torno de',
      traditionalTaxis: 'Táxis Convencionais / Passeios',
      easyWayGas: 'Easy Way (Carro + Combustível Est.)',
      taxiTotal: 'Custo Estimado de Táxi e Passeio',
      carTotal: 'Custo Total com Easy Way (Carro + Combustível)',
      savingsTotal: 'Sua Economia Líquida Estimada!',
      celebrateBtn: 'Calcular e Celebrar Economia!',
      secureSavingsBtn: 'Garanta Essas Economias com a Easy Way',
      bookWithPlan: 'Fazer Cotação Deste Roteiro na Easy Way',
      adviceText: 'Reserve com antecedência na Easy Way para garantir a melhor tarifa disponível para Cancun e a Riviera Maya.',
    },
    roadtrips: {
      badge: 'Roteiros de Direção Recomendados',
      title: 'Roteiros Cênicos saindo de Cancun pela Riviera Maya e Yucatán',
      subtitle: 'Projetados para maximizar cada quilômetro na estrada: tempos exatos de direção, paradas estratégicas e orientações de estacionamento.',
      difficulty: 'Dificuldade',
      gasEst: 'Est. Combustível',
      tolls: 'Pedágios',
      stopsTitle: 'Roteiro Sugerido',
      carTip: 'Dica de Direção',
    },
    drivingGuide: {
      badge: 'Guia de Direção Quintana Roo e Yucatán',
      title: 'Dicas Essenciais de Direção em Cancun e Riviera Maya',
      subtitle: 'Regras de trânsito, mitos do seguro do cartão de crédito, protocolos de blitz policial e como evitar golpes em postos de gasolina.',
      tabInsurance: 'Seguro Obrigatório',
      tabLegal: 'Blitz e Leis',
      tabDriving: 'Combustível e Rodovias',
      assistanceBadge: 'Assistência Rodoviária 24/7',
      needCarTitle: 'Planejando seu Roteiro em Cancun e Riviera Maya?',
      needCarSubtitle: 'Reserve com a Easy Way Rent a Car: seguro transparente, quilometragem ilimitada e recepção rápida no Aeroporto de Cancun.',
      goToEasyWay: 'Cotar no Aeroporto de Cancún',
      crossNavTitle: 'Chegando de Avião no Aeroporto de Cancun (CUN)?',
      crossNavSubtitle: 'Confira nosso guia sobre limites alfandegários, documentos de imigração, câmbio e como evitar as abordagens no desembarque.',
      crossNavBtn: 'Ver Dicas de Aeroporto e Viagem',
      cdwTitle: 'O Grande Mito do Seguro do Cartão de Crédito no México',
      gasTitle: 'Protocolos de Postos de Gasolina Locais',
      policeTitle: 'Blitz Policial e Regras de Trânsito',
      tollsTitle: 'Estradas Gratuitas vs Rodovias com Pedágio',
    },
    driving: {
      badge: 'Guia de Direção Quintana Roo e Yucatán',
      title: 'Dicas Essenciais de Direção em Cancun e Riviera Maya',
      subtitle: 'Regras de trânsito, mitos do seguro do cartão de crédito, protocolos de blitz policial e como evitar golpes em postos de gasolina.',
      tabInsurance: 'Seguro Obrigatório',
      tabLegal: 'Blitz e Leis',
      tabDriving: 'Combustível e Rodovias',
      assistanceBadge: 'Assistência Rodoviária 24/7',
      needCarTitle: 'Planejando seu Roteiro em Cancun e Riviera Maya?',
      needCarSubtitle: 'Reserve com a Easy Way Rent a Car: seguro transparente, quilometragem ilimitada e recepção rápida no Aeroporto de Cancun.',
      goToEasyWay: 'Cotar no Aeroporto de Cancún',
      crossNavTitle: 'Chegando de Avião no Aeroporto de Cancun (CUN)?',
      crossNavSubtitle: 'Confira nosso guia sobre limites alfandegários, documentos de imigração, câmbio e como evitar as abordagens no desembarque.',
      crossNavBtn: 'Ver Dicas de Aeroporto e Viagem',
      cdwTitle: 'O Grande Mito do Seguro do Cartão de Crédito no México',
      gasTitle: 'Protocolos de Postos de Gasolina Locais',
      policeTitle: 'Blitz Policial e Regras de Trânsito',
      tollsTitle: 'Estradas Gratuitas vs Rodovias com Pedágio',
    },
    travel: {
      badge: 'Guia de Chegada ao Aeroporto de Cancun',
      title: 'Guia Prático de Viagem: Alfândega, Moeda e Desembarque',
      subtitle: 'Tudo o que você precisa saber desde o minuto em que seu voo pousa até você pegar as chaves do seu aluguel da Easy Way sem problemas.',
    },
    events: {
      badge: 'Agenda Cultural e Festivais',
      title: 'Eventos Anuais e Celebrações em Cancun',
      subtitle: 'Experimente música ao vivo, folclore e tradições maias facilmente acessíveis de carro o ano todo.',
    },
    faq: {
      badge: 'Perguntas Frequentes',
      title: 'Guia de Viagem de Cancun e Perguntas Frequentes sobre Aluguel de Carros',
      subtitle: 'Respostas claras e diretas sobre o aluguel de carros com a Easy Way, estradas locais e estacionamento.',
      checkFleet: 'Verificar frota oficial e disponibilidade',
    },
    faqs: {
      badge: 'Perguntas Frequentes',
      title: 'Guia de Viagem de Cancun e Perguntas Frequentes sobre Aluguel de Carros',
      subtitle: 'Respostas claras e directas sobre o aluguel de carros com a Easy Way, estradas locais e estacionamento.',
      checkFleet: 'Verificar frota oficial e disponibilidade',
    },
    footer: {
      topBadge: 'A melhor escolha em aluguel de carros',
      topTitle: 'Pronto para Descobrir Cancun no Seu Próprio Ritmo?',
      topSubtitle: 'Reserve seu carro com a Easy Way Rent a Car. Mais de 25 anos garantindo tarifas honestas, sem surpresas e sem depósitos predatórios no Caribe Mexicano.',
      quoteBtn: 'Cotar Carro no Aeroporto de Cancún',
      brandDesc: 'Guia independente de viagens de carro e mobilidade para Cancun, Riviera Maya e Península de Yucatán. Conselhos objetivos e verificados para uma exploração sem complicações.',
      destinationsTitle: 'Destinos Populares',
      experiencesTitle: 'Roteiros e Conselhos',
      recommendationPill: 'Recomendado',
      recommendationDesc: 'A sua melhor escolha em aluguel de carros com mais de 25 anos no Caribe Mexicano. Tarifas honestas com seguro obrigatório incluído.',
      quickLinks: 'Navegação do Guia',
      disclaimer: 'Guia educacional de mobilidade em viagens. Promovemos a exploração segura, responsável e transparente das estradas em Cancun e na Península de Yucatán.',
      allRights: 'Todos os direitos reservados.',
      websiteUrl: 'easywayrentacar.com',
      copyright: '© 2026 CancunMexico.travel — Todos os direitos reservados.',
      craftedFor: 'Projetado para uma experiência de viagem de carro inigualável no Caribe Mexicano.',
    },
    modal: {
      drivingTime: 'Tempo estimado de direção',
      parking: 'Informações de estacionamento',
      whyCar: 'Por que visitar de carro',
      insiderTip: 'Dica local',
      bestTime: 'Melhor época para visitar',
      priceRange: 'Faixa de preço',
      openMaps: 'Abrir no Google Maps',
      quoteCar: 'Cotar Carro para este Destino com a Easy Way',
      close: 'Fechar',
      recommendedMobility: 'Mobilidade Recomendada',
    },
    floating: {
      whatsappChat: 'WhatsApp Easy Way',
      callDirect: 'Ligar para Easy Way',
      openQuote: 'Reservar Online',
      websiteUrl: 'easywayrentacar.com',
    },

  }
} as const;
